import { Component, OnInit, Injectable, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class SpinnerComponent implements OnInit {

  public static isShow:boolean = false
  public isModeMobile: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  public setShow(): void {
    SpinnerComponent.isShow = !SpinnerComponent.isShow;
  }

  public getShow(): boolean {
    return SpinnerComponent.isShow;
  }

}
